import { useNotificationClickHandler } from '@/modules/notification/hooks/useNotificationClickHandler'

/**
 * Component that handles notification clicks from service worker
 * Must be rendered inside a Router context
 *
 * This enables PWA notification click navigation by:
 * 1. Listening for NOTIFICATION_CLICK messages from the service worker
 * 2. Using React Router to navigate to the URL specified in the notification
 */
export function NotificationClickHandler() {
	useNotificationClickHandler()
	return null
}
